jQuery(document).ready(function($){
	var mainHeader = $('.faktotum-auto-hide-header'),
		secondaryNavigation = $('.faktotum-secondary-nav'),
		navTrigger = $('.js-nav-trigger'),
		navWrapper = $('.js-nav-wrapper'),
		//this applies only if secondary nav is below intro section
		belowNavHeroContent = $('.sub-nav-hero'),
		headerHeight = mainHeader.height(),
		menuHasChildren = $('.menu-item-has-children > a'),
		subMenu = $('.sub-menu'),
		menuOpen = false;
	
	//set scrolling variables
	var scrolling = false,
		previousTop = 0,
		currentTop = 0,
		scrollDelta = 10,
		scrollOffset = 150;

	mainHeader.on('click', '.nav-trigger', function(event){
		$('body').toggleClass('menu-open');
		mainHeader.toggleClass('menu-open');
		event.preventDefault();
		navWrapper.toggleClass('menu-open');
		menuOpen = !menuOpen;
	});

	$(document).on('click', function(event) {
        // Check if the navigation is open and the clicked element is not a descendant of navTrigger or navWrapper
        if (menuOpen && !$(event.target).closest(navTrigger).length && !$(event.target).closest(navWrapper).length) {
            navWrapper.removeClass('menu-open');
			menuOpen = false;
        }
    });



	$(window).on('scroll', function(){
		if( !scrolling ) {
			scrolling = true;
			(!window.requestAnimationFrame)
				? setTimeout(autoHideHeader, 250)
				: requestAnimationFrame(autoHideHeader);
		}
	});

	$(window).on('resize', function(){
		headerHeight = mainHeader.height();
	});

	function autoHideHeader() {
		var currentTop = $(window).scrollTop();

		( belowNavHeroContent.length > 0 ) 
			? checkStickyNavigation(currentTop) // secondary navigation below intro
			: checkSimpleNavigation(currentTop);

	   	previousTop = currentTop;
		scrolling = false;
	}

	function checkSimpleNavigation(currentTop) {
		//there's no secondary nav or secondary nav is below primary nav
	    if (previousTop - currentTop > scrollDelta) {
	    	//if scrolling up...
	    	mainHeader.removeClass('is-small');
	    } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
	    	//if scrolling down...
	    	mainHeader.addClass('is-small');
	    }
	}

	function checkStickyNavigation(currentTop) {
		//secondary nav below intro section - sticky secondary nav
		var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();
		
		if (previousTop >= currentTop ) {
	    	//if scrolling up... 
	    	if( currentTop < secondaryNavOffsetTop ) {
	    		//secondary nav is not fixed
	    		mainHeader.removeClass('is-small');
	    		secondaryNavigation.removeClass('fixed slide-up');
	    		belowNavHeroContent.removeClass('secondary-nav-fixed');
	    	} else if( previousTop - currentTop > scrollDelta ) {
	    		//secondary nav is fixed
	    		mainHeader.removeClass('is-small');
	    		secondaryNavigation.removeClass('slide-up').addClass('fixed'); 
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}
	    	
	    } else {
	    	//if scrolling down...	
	 	  	if( currentTop > secondaryNavOffsetTop + scrollOffset ) {
	    		mainHeader.addClass('is-small');
	    		secondaryNavigation.addClass('fixed slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	} else if( currentTop > secondaryNavOffsetTop ) {
	    		//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset 
	    		mainHeader.removeClass('is-small');
	    		secondaryNavigation.addClass('fixed').removeClass('slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}

	    }
	}

	// handle sub menu
	//================


/////////////////// WORKING
	// $(document).ready(function() {
	// 	// Function to move sub-menus
	// 	function moveMenus() {
	// 		if ($(window).width() > 1024) {
	// 			// Move the main navigation back to its original position
	// 			if ($('.js-main-nav-holder .faktotum-navigation').length === 0) {
	// 				$('.js-subnav-holder .faktotum-navigation').detach().appendTo('.js-main-nav-holder');
	// 			}
	
	// 			// Move sub-menus under js-subnav-holder
	// 			$('.faktotum-primary-nav .menu-item-has-children').each(function() {
	// 				var parentId = $(this).attr('id');
	// 				var subMenu = $(this).find('.sub-menu').first();
	// 				if (subMenu.length > 0) {
	// 					subMenu.detach().appendTo('.js-subnav-holder').attr('data-parent-id', parentId);
	// 				}
	// 			});
	// 		} else {
	// 			// Move the main navigation to js-subnav-holder
	// 			if ($('.js-subnav-holder .faktotum-navigation').length === 0) {
	// 				$('.faktotum-navigation').detach().appendTo('.js-subnav-holder');
	// 			}
	
	// 			// Move sub-menus back to their original parent
	// 			$('.js-subnav-holder .sub-menu').each(function() {
	// 				var parentId = $(this).attr('data-parent-id');
	// 				var parentItem = $('#' + parentId);
	// 				if (parentItem.length > 0) {
	// 					$(this).detach().appendTo(parentItem);
	// 				}
	// 			});
	// 		}
	// 	}
	
	// 	moveMenus();
	
	// 	$(window).resize(function() {
	// 		moveMenus();
	// 	});
	
	// 	// Toggle open class on clicking menu-item-has-children > a
	// 	$('.menu-item-has-children > a').click(function(e) {
	// 		e.preventDefault();
	// 		var parentId = $(this).parent().attr('id');
	// 		var subMenu = $('.js-subnav-holder').find('.sub-menu[data-parent-id="' + parentId + '"]');
	
	// 		if (subMenu.length > 0) {
	// 			// Close all other open sub-menus
	// 			$('.js-subnav-holder .sub-menu').not(subMenu).removeClass('open');
	// 			// Toggle open class on the clicked sub-menu
	// 			subMenu.toggleClass('open');
	// 		}
	// 	});
	
	// 	// Close sub-menus if clicked outside
	// 	$(document).on('click', function(e) {
	// 		if (!$(e.target).closest('.menu-item-has-children').length) {
	// 			$('.js-subnav-holder .sub-menu').removeClass('open');
	// 		}
	// 	});
	// });
///////////////////
	

	


$(document).ready(function() {
    // Variables for commonly used elements
    var $window = $(window);
    var $mainNavHolder = $('.js-main-nav-holder');
    var $subNavHolder = $('.js-subnav-holder');
    var $primaryNav = $('.faktotum-primary-nav');
    var $navigation = $('.faktotum-navigation');
    var $menuItems = $('.faktotum-primary-nav .menu-item-has-children');
    var $document = $(document);

    // Function to move sub-menus
    function moveMenus() {
        if ($window.width() > 1409) {
            // Move the main navigation back to its original position
            if ($mainNavHolder.find('.faktotum-navigation').length === 0) {
                $subNavHolder.find('.faktotum-navigation').detach().appendTo($mainNavHolder);
            }

            // Move sub-menus under js-subnav-holder
            $menuItems.each(function() {
                var parentId = $(this).attr('id');
                var $subMenu = $(this).find('.sub-menu').first();
                if ($subMenu.length > 0) {
                    $subMenu.detach().appendTo($subNavHolder).attr('data-parent-id', parentId);
                }
            });
        } else {
            // Move the main navigation to js-subnav-holder
            if ($subNavHolder.find('.faktotum-navigation').length === 0) {
                $navigation.detach().appendTo($subNavHolder);
            }

            // Move sub-menus back to their original parent
            $subNavHolder.find('.sub-menu').each(function() {
                var parentId = $(this).attr('data-parent-id');
                var $parentItem = $('#' + parentId);
                if ($parentItem.length > 0) {
                    $(this).detach().appendTo($parentItem);
                }
            });
        }
    }

    moveMenus();

    $window.resize(function() {
        moveMenus();
    });

    // Toggle open class on clicking menu-item-has-children > a
    $menuItems.children('a').click(function(e) {
        e.preventDefault();
        var parentId = $(this).parent().attr('id');
        var $subMenu = $subNavHolder.find('.sub-menu[data-parent-id="' + parentId + '"]');

		$(this).toggleClass('open');
        if ($subMenu.length === 0) {
            $subMenu = $(this).siblings('.sub-menu');
        }

        if ($subMenu.length > 0) {
            // Close all other open sub-menus
            $subNavHolder.find('.sub-menu').not($subMenu).removeClass('open');
            $navigation.find('.sub-menu').not($subMenu).removeClass('open');
            // Toggle open class on the clicked sub-menu
            $subMenu.toggleClass('open');
        }
    });

    // Close sub-menus if clicked outside
    $document.on('click', function(e) {
        if (!$(e.target).closest('.menu-item-has-children').length) {
            $subNavHolder.find('.sub-menu').removeClass('open');
            $navigation.find('.sub-menu').removeClass('open');
        }
    });
});


	
});

